export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/minivan.2a3b6d02.svg","height":31,"width":84,"blurWidth":0,"blurHeight":0};